import React from "react";
import {
  BoostrapAccordionItem,
  AccordionItemHeader,
  AccordionItemBody,
} from "wm_global";

export const FAQAccordionItem = ({
  question,
  answer,
  icon,
  itemId,
  accordionId,
}) => {
  return (
    <BoostrapAccordionItem>
      <AccordionItemHeader itemId={itemId}>
        <section>
          <div className="d-flex align-items-center">
            <div className="faq-icon">{icon}</div>
            <div className="faq-question-div">
              <b>{question}</b>
            </div>
          </div>
        </section>
      </AccordionItemHeader>
      <AccordionItemBody itemId={itemId} accordionId={accordionId}>
        {answer}
      </AccordionItemBody>
    </BoostrapAccordionItem>
  );
};
